import httpHelper from '../../../../utils/httpHelper';
import { appConfig } from '../../../../constants/appConfig';

const service = {

  async getDeviceList(params) {
    const endPoint = `device/getDeviceList`;
    const result = await httpHelper.makeGetRequest(
      appConfig.baseUrl,
      endPoint,
      params,
    );
    return result;
  },

  async getDeviceByBarcodeNumber(params) {
    const endPoint = `device/findDeviceByBarcodeNumber?barcodeNumber=${params.barcodeNumber}`;
    const result = await httpHelper.makeGetRequest(
      appConfig.baseUrl,
      endPoint,
    );
    return result;
  },

  async saveDevice(payload) {
    const endPoint = 'device/saveDevice';
    const result = await httpHelper.makePostRequest(
      appConfig.baseUrl,
      endPoint,
      payload,
    );
    return result;
  },

  async deleteDevice(params) {
    const endPoint = `device/delete?id=${params.id}`;
    const result = await httpHelper.makeDeleteRequest(
      appConfig.baseUrl,
      endPoint,
    );
    return result;
  },

  async updateDevice(payload) {
    const endPoint = `device/updateDevice?deviceId=${payload.deviceId}`;
    const result = await httpHelper.makePutRequest(
      appConfig.baseUrl,
      endPoint,
      payload.data
    );
    return result;
  },

  async getDevicesWithSearch(params) {
    const endPoint = `device/findDeviceSearch`;
    const result = await httpHelper.makeGetRequest(
      appConfig.baseUrl,
      endPoint,
      params,
    );
    return result;
  },
};

export default service;
